(function(){
  function fmtMoney(v){return '$'+Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');}

  function initChart(root){
    var D; try{D=JSON.parse(root.querySelector('[data-idx-data]').textContent);}catch(e){return;}
    var svg=root.querySelector('[data-idx-svg]'), numEl=root.querySelector('[data-idx-num]'), dEl=root.querySelector('[data-idx-delta]');
    var isLight=root.classList.contains('is-light');
    // Rental isn't a positive/negative signal, just a reference line -- neutral ink tone in light
    // mode (not green, reserved for semantic up/down elsewhere), not the dark-mode cream that was
    // invisible against a light background -- that mismatch was the actual bug being fixed here.
    var lineColor=isLight?'#1A1A1A':'#E8DFCC';
    var fillTop=isLight?'rgba(26,26,26,.12)':'rgba(232,223,204,.18)';
    var gridColor=isLight?'rgba(26,26,26,.07)':'rgba(255,255,255,.06)';
    function draw(key){
      var s=D[key]; if(!s||!svg)return;
      var d=s.pts, min=Math.min.apply(null,d)-4, max=Math.max.apply(null,d)+3, W=600,H=160,p=6;
      var pts=d.map(function(v,i){return [p+i/(d.length-1)*(W-p*2), H-p-((v-min)/(max-min))*(H-p*2-16)];});
      var line=pts.map(function(pt,i){return (i?'L':'M')+pt[0].toFixed(1)+' '+pt[1].toFixed(1);}).join(' ');
      var area=line+' L'+pts[pts.length-1][0].toFixed(1)+' '+H+' L'+pts[0][0].toFixed(1)+' '+H+' Z';
      svg.innerHTML='<defs><linearGradient id="rlg" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="'+fillTop+'"/><stop offset="1" stop-color="transparent"/></linearGradient></defs>'
        +[0,1,2].map(function(i){return '<line x1="0" x2="'+W+'" y1="'+(p+i*(H-p*2)/2)+'" y2="'+(p+i*(H-p*2)/2)+'" stroke="'+gridColor+'"/>';}).join('')
        +'<path d="'+area+'" fill="url(#rlg)"/><path d="'+line+'" fill="none" stroke="'+lineColor+'" stroke-width="2"/>'
        +'<circle cx="'+pts[pts.length-1][0].toFixed(1)+'" cy="'+pts[pts.length-1][1].toFixed(1)+'" r="3" fill="'+lineColor+'"/>';
      if(numEl)numEl.textContent=d[d.length-1].toFixed(1);
      if(dEl)dEl.textContent=s.delta;
    }
    [].forEach.call(root.querySelectorAll('[data-idx-tabs] button'),function(b){b.addEventListener('click',function(){
      [].forEach.call(root.querySelectorAll('[data-idx-tabs] button'),function(x){x.classList.toggle('on',x===b);}); draw(b.dataset.range);});});
    draw('5y');
  }

  function initRental(root){
    var D; try{D=JSON.parse(root.querySelector('[data-rent-data]').textContent);}catch(e){return;}
    var townSel=root.querySelector('[data-rent-town]'), typeSel=root.querySelector('[data-rent-type]');
    if(townSel&&!townSel.options.length){
      townSel.innerHTML=Object.keys(D.towns).map(function(t){return '<option'+(t==='Tampines'?' selected':'')+'>'+t+'</option>';}).join('');
    }
    function calc(){
      var town=townSel.value, type=typeSel.value, region=D.towns[town]||'North-East', f=D.regionFactor[region]||1;
      var base=D.baseRent[type], lo=Math.round(base[0]*f/50)*50, hi=Math.round(base[1]*f/50)*50, mid=(lo+hi)/2;
      var price=(D.basePrice[type]||760000)*f, yld=mid*12/price*100;
      var set=function(sel,val){var el=root.querySelector(sel); if(el)el.textContent=val;};
      set('[data-rent-est]',fmtMoney(mid));
      set('[data-rent-range]','Range '+fmtMoney(lo)+' – '+fmtMoney(hi));
      set('[data-rent-yield]',yld.toFixed(2)+'%');
    }
    if(townSel)townSel.addEventListener('change',calc);
    if(typeSel)typeSel.addEventListener('change',calc);
    calc();
  }

  function init(root){
    if(!root||root.dataset.rowInit)return; root.dataset.rowInit='1';
    initChart(root);
    initRental(root);
  }
  function all(){[].forEach.call(document.querySelectorAll('[data-hdb-rental-row]'),init);}
  if(document.readyState!=='loading')all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',function(e){var el=e.target.querySelector('[data-hdb-rental-row]'); if(el){el.dataset.rowInit=''; init(el);}});
})();
